import React from 'react';
import { MapPin, Clock, MessageCircle } from 'lucide-react';

const Hero = () => {
  const whatsappNumber = "18099640099";
  const whatsappMessage = "Hola, me gustaría alquilar un vehículo en República Dominicana";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background with Logo */}
      <div className="absolute inset-0 z-0 bg-black">
        {/* Large centered logo as background */}
        <div className="absolute inset-0 flex items-center justify-center">
          <img 
            src="https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/eah2h1s1_logo%20empresa.jpeg"
            alt="La Rent Car de la Isla Logo"
            className="w-full max-w-4xl h-auto object-contain opacity-25"
          />
        </div>
        {/* Gradient overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-12 lg:px-20 py-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-yellow-700/20 border border-yellow-700/30 rounded-sm px-4 py-2 mb-8">
            <span className="text-yellow-600 text-sm font-medium">Servicio Premium 24/7</span>
          </div>

          {/* Main Title */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Alquiler de Vehículos en República Dominicana
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-white/85 mb-8 leading-relaxed">
            Entrega en aeropuerto, hoteles y cualquier parte del país. 
            Atención personalizada 24/7 para turistas.
          </p>

          {/* Features */}
          <div className="flex flex-col sm:flex-row gap-6 mb-10">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-yellow-700/20 border border-yellow-700/30 flex items-center justify-center">
                <MapPin className="w-6 h-6 text-yellow-600" />
              </div>
              <div>
                <p className="text-white font-medium">Entrega en</p>
                <p className="text-white/70 text-sm">Aeropuerto y Hoteles</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-yellow-700/20 border border-yellow-700/30 flex items-center justify-center">
                <Clock className="w-6 h-6 text-yellow-600" />
              </div>
              <div>
                <p className="text-white font-medium">Disponible</p>
                <p className="text-white/70 text-sm">24 horas, 7 días</p>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-yellow-700 text-black px-8 py-4 font-semibold text-lg hover:bg-yellow-600 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-700/50 hover:scale-105"
            >
              <MessageCircle className="w-6 h-6" />
              Reservar por WhatsApp
            </a>
            <button
              onClick={() => document.getElementById('vehiculos').scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center justify-center gap-3 bg-white/10 text-white px-8 py-4 font-semibold text-lg border border-white/20 hover:bg-white hover:text-black transition-all duration-300"
            >
              Ver Vehículos
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-yellow-700/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-yellow-600 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
